// import { config } from 'src/vuex/getters'
import panels from 'src/components/nav/panels'
import type_subFieldset from '../../subFieldset'
import type_dateGroup from 'src/components/inputs/date/date-group'
import rawHtml from 'src/components/forms/_sub/rawHtml'
import collapse from 'src/components/forms/_sub/fieldsets/collapsable'

export default {

  data () {
    return {
      uid: this.$parent.uid,
      show: true
    }
  },
  // vuex: {
  //   getters: {
  //     config
  //   }
  // },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  },
  components: {
    type_dateGroup,
    type_subFieldset,
    type_panels: panels,
    type_rawHtml: rawHtml,
    collapse
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/_sub/fieldsets/_shared/traits.js